import axios from 'axios'
import uuid from '@huaying/hy-vue-common/src/utils/uuid'

export function getFileExtension (filename, defaultExt = 'jpg') {
  const ext = filename.split('.').pop()
  return (ext === filename) ? defaultExt : ext
}

export function isImageExt (ext) {
  const imageExts = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'bmp']
  return imageExts.some(imageExt => ext.indexOf(imageExt) !== -1)
}

export function qiniuFactory (configApi) {
  function getQiniuToken () {
    const { getQiniuToken } = configApi

    return getQiniuToken().then((res) => {
      const { host, token, uploadDomain } = res

      const qiniuHost = host.endsWith('/') ? host : `${host}/`

      return {
        uploadDomain: uploadDomain || 'http://up.qiniu.com',
        host: qiniuHost,
        token
      }
    })
  }

  function getFilename (prefix, ext = 'png') {
    if (prefix.endsWith('/')) {
      return `${prefix}${uuid()}.${ext}`
    }
    return `${prefix}-${uuid()}.${ext}`
  }

  function upload (fileData, filename) {
    return getQiniuToken().then((res) => {
      const uploadForm = new FormData()
      uploadForm.append('token', res.token)
      uploadForm.append('file', fileData)
      uploadForm.append('key', filename)

      return axios({
        method: 'POST',
        url: res.uploadDomain,
        data: uploadForm
      })
    })
  }

  return {
    getFileExtension,
    getQiniuToken,
    getFilename,
    upload
  }
}



// WEBPACK FOOTER //
// ./src/utils/qiniu.js